export enum BankIntegrationActionPoint {
  GoToBankReconciliation = 1,
  ConnectBank = 2,
  RenewConnection = 3,
  UpgradeToPremium = 4,
  ThingsToDo = 5,
}
